var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger-button",class:{ open: _vm.isOpen },attrs:{"aria-label":"Toggle menu"},on:{"click":_vm.toggle}},[_c('span',{staticClass:"hamburger-line"}),_c('span',{staticClass:"hamburger-line"}),_c('span',{staticClass:"hamburger-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }